const DateToday = () => {
  var today = new Date();
  return today;
};

export default DateToday;
